import { GraphPayload, GraphQueryInput, createQuery } from '@ta/server';

import { Company } from './dto/company';

export function myCompanyQuery(input: GraphQueryInput<Company>): GraphPayload {
  return createQuery<Company>('myCompany', { ...input, prefixType: 'Company' });
}

export function companiesQuery(input: GraphQueryInput<Company>): GraphPayload {
  return createQuery<Company>('companies', { ...input, prefixType: 'Company' });
}
